import { useTranslation } from 'react-i18next'

import { Link } from 'react-router-dom'

import { useAppSettings } from '@/stores/useAppSettings'

import { paths } from '@/config/paths'

import { DropdownMenu } from '@/components/ui/dropdown-menu'
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar'

export function SidebarLogo() {
  const { t } = useTranslation(['common', 'auth'])
  const { getSetting } = useAppSettings()

  const logoSetting = getSetting('branding.app_logo_url')
  const appLogo = typeof logoSetting === 'string' && logoSetting.trim() ? logoSetting : '/barbella_logo2.png'
  const appNameSetting = getSetting('general.app_name')
  const appName = typeof appNameSetting === 'string' && appNameSetting.trim() ? appNameSetting : 'Barbella Gym'

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <SidebarMenuButton
            asChild
            className='data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground cursor-pointer'
            size='lg'
          >
            <Link to={paths.dashboard.root.getHref()}>
              <img
                src={appLogo}
                alt={t('auth:appLogo.alt', { defaultValue: `${appName} Logo`, appName })}
                className='max-h-8 w-auto object-contain'
                loading='lazy'
              />
            </Link>
          </SidebarMenuButton>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
